import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function UrgencySection() {
  return <section className="py-12 px-4 bg-brand-red/10 border-y border-brand-red/30" data-id="element-284">
      <div className="max-w-3xl mx-auto text-center" data-id="element-285">
        <h3 className="text-2xl md:text-3xl font-bold text-white mb-6" data-id="element-286">
          Atención: Esta oferta especial con todos los bonos desaparece en:
        </h3>

        <div className="flex justify-center mb-6" data-id="element-287">
          <CountdownTimer size="lg" data-id="element-288" />
        </div>

        <p className="text-brand-red font-medium text-lg" data-id="element-289">
          Una vez que el contador llegue a cero, el precio volverá a la
          normalidad y los bonos se venderán por separado.
        </p>
      </div>
    </section>;
}